import { isDevMode } from '@angular/core';
import { Route } from '@angular/router';
import { SplUiThemePreviewFeature } from './theme-preview.feature';

export const splUiThemePreviewFeatureRoute: Route = {
  path: 'spl-ui-theme-preview',
  component: SplUiThemePreviewFeature,
  title: 'Theme Preview',
  canActivate: [() => isDevMode()],
};
